import { Box, Grid } from "@mui/material"
import CreateCompetitionLiveCustom from "./CreateCompetitionLiveCustom.js";
import CreateMatchLiveCustom from "./CreateMatchLiveCustom.js";
import { Can } from "../../../permissions/Can.js";
import { PERMISSIONS } from "../../../permissions/permissionKeys.js";

//SPORT LIVE PAGE - FORM LIVE CONTAINER CUSTOM

const FormLiveContainerCustom = ({currentId, setCurrentId}) => {

    return <Box display={'grid'}>
        {/*PAGE TITLE*/}
        <Box className='centered-medium-wrapper'>
            <h1 className='page-title'>Gestion des directs</h1>
        </Box>
        <Box className='medium-separator'></Box>
        <Box>
            <Box className="small-padding"></Box>
            <Grid container alignItems="center" spacing={3} className='padding-wrapper'>
                <Grid justifyItems="center" className='centered-wrapper' item xs={12} sm={12} md={6}>
                    {/*Create a live by competition*/}
                    <Can permission={PERMISSIONS.SPORT_LIVES_HOME_BUTTON_CREATE}>
                        <CreateCompetitionLiveCustom currentId={currentId} setCurrentId={setCurrentId} />
                    </Can>
                    
                </Grid>
                <Grid justifyItems="center" className='centered-wrapper' item xs={12} sm={12} md={6}>
                    {/*Create a live by match*/}
                    <Can permission={PERMISSIONS.SPORT_LIVES_HOME_BUTTON_CREATE}>
                        <CreateMatchLiveCustom />
                    </Can>
                    
                </Grid>
            </Grid>
        </Box>
    </Box>
}

export default FormLiveContainerCustom
